export const userToken =  "userToken"
export const API_URL = process.env.REACT_APP_API_URL;
export const IS_PROD= process.env.REACT_APP_PROD;
export const PAYMENAT_SUCCESS_URL= process.env.REACT_APP_PAYMENAT_SUCCESS_URL;
export const PAYMENAT_FAILURE_URL= process.env.REACT_APP_PAYMENAT_FAILURE_URL;